<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view/>
</template>

<style lang="scss">
#app {
  max-width: 650px;
  margin: 0 auto;
  background-color: #FFFFFF;
  font-family: PingFang-SC, Helvetica Neue, Helvetica, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  >div{
    background-color: #FFFFFF;
  }
}
</style>
